export default {
    GET_LOCALE (state) {
        return state.locale
    }
}
